module.exports = __webpack_public_path__ + "static/media/noConection.88bf9e30.svg";